/* tslint:disable */
/* eslint-disable */
/**
 * EcoCerram API
 * EcoCerram API generated from BE
 *
 * The version of the OpenAPI document: 0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangePasswortDto
 */
export interface ChangePasswortDto {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswortDto
     */
    oldPassword?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswortDto
     */
    newPassword?: string;
}

/**
 * Check if a given object implements the ChangePasswortDto interface.
 */
export function instanceOfChangePasswortDto(value: object): value is ChangePasswortDto {
    return true;
}

export function ChangePasswortDtoFromJSON(json: any): ChangePasswortDto {
    return ChangePasswortDtoFromJSONTyped(json, false);
}

export function ChangePasswortDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangePasswortDto {
    if (json == null) {
        return json;
    }
    return {
        
        'oldPassword': json['oldPassword'] == null ? undefined : json['oldPassword'],
        'newPassword': json['newPassword'] == null ? undefined : json['newPassword'],
    };
}

export function ChangePasswortDtoToJSON(json: any): ChangePasswortDto {
    return ChangePasswortDtoToJSONTyped(json, false);
}

export function ChangePasswortDtoToJSONTyped(value?: ChangePasswortDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'oldPassword': value['oldPassword'],
        'newPassword': value['newPassword'],
    };
}

